//import the Polymer library
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import "@polymer/polymer/lib/elements/dom-repeat.js";

import "./FilterWebinarStatus.style"

class FilterWebinarStatus extends PolymerElement {
    static get template() {
        return html `
        <style include="filter-webinar-status-style"></style>
        <div class="filter-webinar-status-container">
            <h2>Berdasarkan Waktu</h2>
            <hr>
            <div class="webinar-status-list-container">
                <dom-repeat items="{{webinarStatusListData}}" as="webinarStatusItem">
                    <template>
                        <div class="item-webinar-status-container">
                            <label>
                                <dom-if if="{{_isLocalStorage(webinarStatusItem, isTicked)}}">
                                    <template>
                                        <input type="radio" name="webinarTimeSessVal" value="{{webinarStatusItem.value}}" on-click="_chooseWebinarStatus" checked>
                                        {{webinarStatusItem.name}}
                                    </template>
                                </dom-if>

                                <dom-if if="{{!_isLocalStorage(webinarStatusItem, isTicked)}}">
                                    <template>
                                        <input type="radio" name="webinarTimeSessVal" value="{{webinarStatusItem.value}}" on-click="_chooseWebinarStatus">
                                        {{webinarStatusItem.name}}
                                    </template>
                                </dom-if>
                            <label>
                        </div>
                    <template>
                </dom-repeat>
            </div>
        </div>
        `;
    }

    static get properties() {
        return {
            isTicked: {
                type: Boolean,
                value: true,
            },

            webinarStatusListData: {
                type: Array,
                value() {
                    return [{
                            "name": "Semua",
                            "value": "all"
                        },
                        {
                            "name": "Akan Datang",
                            "value": "publish"

                        },
                        {
                            "name": "Berlangsung",
                            "value": "live"
                        },
                        {
                            "name": "Selesai",
                            "value": "finished"
                        }
                    ];
                }
            }
        }
    }

    ready() {
        super.ready()
    }

    _isLocalStorage(webinarStatusItem, isTicked) {
        let currentUrl = (new URL(document.location)).searchParams;
        let timeSession = currentUrl.get('time_session')

        if (webinarStatusItem.value == timeSession) {
            return isTicked
            
       } else {
            return webinarStatusItem.value == "all"
       }
    }

    _chooseWebinarStatus(e) {
        var selected_radio = e.target.value
        let currentUrl = (new URL(document.location)).searchParams;
        var queryParams = new URLSearchParams(window.location.search);
        let timeSession = currentUrl.get('time_session') 

        if (selected_radio == timeSession) {
            return window.stop()

        } else {
            queryParams.set("time_session", selected_radio);
            queryParams.set("page", 1);
            let newUrlParam = new URL(window.location.origin + "/webinar" + "?" + queryParams.toString());
            let multipleParams = newUrlParam
            return window.location = multipleParams
        }
    }
}
customElements.define("filter-webinar-tatus", FilterWebinarStatus);